module.exports = __webpack_public_path__ + "static/media/team-left-image.392cd764.png";